import { render, staticRenderFns } from "./VehicleItemEditPage.vue?vue&type=template&id=287adb72&scoped=true&"
import script from "./VehicleItemEditPage.vue?vue&type=script&lang=js&"
export * from "./VehicleItemEditPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "287adb72",
  null
  
)

export default component.exports